// export const BASE_URL = "https://api.alnukhbeh-edu.com/"
export const BASE_URL = "https://api.almashriq.edunixsystem.com/"

export const STORAGE_NAME = "auth"
export const STORAGE_ACTIVE_USER = "active-user"